<div>
    <div class="p-col-12" *ngFor="let shipmentDetail of shipmentDetails?.builtValues; index as shipmentIndex">
        <div class="p-grid" *ngIf="shipmentDetail?.show">
            <div class="p-p-2 fp-shipment-header fp-text-bold">
                {{shipmentDetail?.label}}
            </div>
            <div class="p-col-12 divider-top">
                <div class="p-grid">
                    <div class="p-col-6 p-md-3 p-lg-4 p-xl-2 p-px-0"
                         *ngFor="let column of shipmentDetail?.columns; index as i">
                        <div class="p-pb-0 p-px-2 p-pt-0 fp-text-bold"
                             [class.divider-bottom]="screenSize > 1200"
                             [style]="screenSize > 1200 ? 'height: 4.7vh;' : ''"
                             [class]="i > 5 && screenSize > 1200 ? 'divider-top p-pt-2' : ''">
                            {{column?.columnLabel}}
                        </div>
                        <div class="p-py-2 p-px-2 p-text-wrap">
                            {{column?.value ? column?.value : '-'}}
                        </div>
                    </div>
                    <div *ngIf="screenSize > 1200" class="p-col p-px-0">
                        <div class="p-py-2" style="height: 4.7vh;"
                             [class.divider-bottom]="screenSize > 1200"
                             [class]="shipmentDetail?.columns?.length > 5 && screenSize > 1200 ? 'divider-top' : ''">
                            {{'&nbsp;'}}
                        </div>
                        <div class="p-py-2">
                            {{'&nbsp;'}}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
